var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "fill-height d-flex flex-column",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('employment-doc-view', _vm._b({}, 'employment-doc-view', {
    contract: _vm.form,
    value: _vm.fields,
    pages: _vm.pages,
    mode: 'done'
  }, false))], 1), _c('client-loader', _vm._b({}, 'client-loader', {
    loading: _vm.loading
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }